"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyCatalogItem = void 0;
function makeEmptyCatalogItem() {
    return {
        Value: '',
        Text: '',
        Object: {},
    };
}
exports.makeEmptyCatalogItem = makeEmptyCatalogItem;
//# sourceMappingURL=CatalogItem.js.map